"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _creative = require("../../constants/creative");

var _getFilterTransform = _interopRequireDefault(require("./getFilterTransform"));

var _Transform = _interopRequireDefault(require("../../models/transform/Transform"));

var getCurrentTransform = function getCurrentTransform(transforms, leftKeyFrame, rightKeyFrame, currentFrame) {
  if (leftKeyFrame === null && rightKeyFrame === null) {
    throw new Error('no animation key frames found');
  }

  if (currentFrame === leftKeyFrame || currentFrame === rightKeyFrame) {
    return transforms[currentFrame];
  }

  if (leftKeyFrame === null) {
    return transforms[rightKeyFrame];
  }

  if (rightKeyFrame === null) {
    return transforms[leftKeyFrame];
  }

  var t = (currentFrame - leftKeyFrame) / (rightKeyFrame - leftKeyFrame);
  var leftTransform = transforms[leftKeyFrame];
  var rightTransform = transforms[rightKeyFrame];
  var f = _creative.EASING_FUNCTIONS[rightTransform.easingFunction] || _creative.EASING_FUNCTIONS[_creative.LINEAR];
  var easingTime = f(t);
  return {
    alpha: _Transform["default"].getEasingValue(leftTransform.alpha, rightTransform.alpha, easingTime),
    easingFunction: _creative.LINEAR,
    // Used as default
    filters: (0, _getFilterTransform["default"])(leftTransform.filters, rightTransform.filters, easingTime),
    rotation: _Transform["default"].getEasingValue(leftTransform.rotation, rightTransform.rotation, easingTime),
    scale: {
      x: _Transform["default"].getEasingValue(leftTransform.scale.x, rightTransform.scale.x, easingTime),
      y: _Transform["default"].getEasingValue(leftTransform.scale.y, rightTransform.scale.y, easingTime)
    },
    translation: {
      x: _Transform["default"].getEasingValue(leftTransform.translation.x, rightTransform.translation.x, easingTime),
      y: _Transform["default"].getEasingValue(leftTransform.translation.y, rightTransform.translation.y, easingTime)
    }
  };
};

var _default = getCurrentTransform;
exports["default"] = _default;